import { Component } from '@angular/core';

import { IconBase } from './icon-base';
@Component({
  selector: 'dollar-circle-bold',
  imports: [],
  template: `
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.75 15.9198H13.4C14.05 15.9198 14.59 15.3398 14.59 14.6398C14.59 13.7698 14.28 13.5998 13.77 13.4198L12.76 13.0698V15.9198H12.75Z" />
      <path
        d="M11.97 1.89992C6.45001 1.91992 1.98001 6.40992 2.00001 11.9299C2.02001 17.4499 6.51001 21.9199 12.03 21.8999C17.55 21.8799 22.02 17.3899 22 11.8699C21.98 6.34992 17.49 1.88992 11.97 1.89992ZM14.26 11.9999C15.04 12.2699 16.09 12.8499 16.09 14.6399C16.09 16.1799 14.88 17.4199 13.4 17.4199H12.75V17.9999C12.75 18.4099 12.41 18.7499 12 18.7499C11.59 18.7499 11.25 18.4099 11.25 17.9999V17.4199H10.89C9.25001 17.4199 7.92001 16.0399 7.92001 14.3399C7.92001 13.9299 8.26001 13.5899 8.67001 13.5899C9.08001 13.5899 9.42001 13.9299 9.42001 14.3399C9.42001 15.2099 10.08 15.9199 10.89 15.9199H11.25V12.5399L9.74001 11.9999C8.96001 11.7299 7.91001 11.1499 7.91001 9.35992C7.91001 7.81992 9.12001 6.57992 10.6 6.57992H11.25V5.99992C11.25 5.58992 11.59 5.24992 12 5.24992C12.41 5.24992 12.75 5.58992 12.75 5.99992V6.57992H13.11C14.75 6.57992 16.08 7.95992 16.08 9.65992C16.08 10.0699 15.74 10.4099 15.33 10.4099C14.92 10.4099 14.58 10.0699 14.58 9.65992C14.58 8.78992 13.92 8.07992 13.11 8.07992H12.75V11.4599L14.26 11.9999Z" />
      <path
        d="M9.42001 9.37008C9.42001 10.2401 9.73001 10.4101 10.24 10.5901L11.25 10.9401V8.08008H10.6C9.95001 8.08008 9.42001 8.66008 9.42001 9.37008Z" />
    </svg>
  `,
  styles: ``,
})
export class DollarCircleBold extends IconBase {}
